.divider {
  border: solid 0 var(--default--border-color--14);
}

.horizontal {
  width: 100%;
  border-bottom-width: 1px;
}

.vertical {
  height: 100%;
  border-right-width: 1px;
}
